module.exports = __webpack_public_path__ + "static/media/bg_symbol_1.dc73c816.svg";